import { useState, useCallback } from 'react'
import { View, Text, TouchableOpacity } from 'react-native'
import Collapsible from 'react-native-collapsible'
import { Entypo } from '@expo/vector-icons'
import { fontPalette } from '../../../static/styles/global'
import { useLabourStore } from '../../../stores/labour'
import { useTranslation } from 'react-i18next'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { useFocusEffect } from '@react-navigation/native';

const NotificationAccordion = ({ item }) => {
  const [isCollapsed, setCollapsed] = useState(true)
  const [viewed, setViewed] = useState(false)
  const labourStore = useLabourStore()
  const [language, setLanguage] = useState('ENG')

  const { t } = useTranslation()




  useFocusEffect(
    useCallback(() => {
      AsyncStorage.getItem('selectedLanguage').then(language => setLanguage(language));
    }, [])
  );

  return (
    <View style={{ margin: 8 }}>
      <TouchableOpacity
        onPress={() => {
          setCollapsed(!isCollapsed)
        }}
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Text
          style={{
            fontSize: 16,
            fontFamily: fontPalette.primaryBold,
            color: viewed ? '#0B495C' : '#A84499',
            flex: 1,
            marginRight: 10
          }}
        >
          {/* {t(item?.notificationName)}{` (${item?.count})`} */}
          {language === 'SPA' ? `${item.notificationNameSpanish} (${item.count})` : `${item?.notificationName} (${item.count})`}
        </Text>

        <Entypo
          name={isCollapsed ? 'chevron-right' : 'chevron-down'}
          size={22}
          color="black"
        />
      </TouchableOpacity>

      <Collapsible collapsed={isCollapsed}>
        {item?.notifications?.map((data) => {
          return (
            <View key={data?.notificationKey} style={{ paddingVertical: 5 }} >
              {/* <Text>{t(data?.notificationName)}</Text> */}
              <Text>{language === 'SPA' ? data.notificationNameSpanish : data?.notificationName}</Text>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  paddingVertical: 8,
                }}
              >
                <Text
                  style={{ flex: 1, marginRight: 10 }}
                >

                  {language === 'SPA' ? data.notificationDescriptionSpanish : data?.notificationDescription}
                </Text>
                <TouchableOpacity
                  onPress={() => {
                    setViewed(!viewed);
                    labourStore.updateNotificationStatus(data.notificationKey);
                  }}
                >
                  <Text style={{ color: "#0099E5", fontFamily: fontPalette.primarySemiBold }}>
                    {t("Mark as read")}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          )
        })}
      </Collapsible>
    </View>
  )
}
export default NotificationAccordion
